// API Configuration
// Centralized API URL management based on environment

const API_ENDPOINTS = {
  sandbox: 'http://localhost:8888',
  development: 'https://api-dev.cleancodeai.co',
  beta: 'https://api-beta.cleancodeai.co',
  live: 'https://api.cleancodeai.co'
};

const getApiBaseUrl = (environment) => {
  return API_ENDPOINTS[environment] || API_ENDPOINTS.sandbox;
};

export const getApiUrl = (environment) => {
  return getApiBaseUrl(environment);
};

// Default API base URL for components that don't have environment context
// This should only be used as a fallback when environment context is not available
export const API_BASE = 'http://localhost:8888';
